import React, { useState, useEffect } from 'react';
import { Provider } from 'react-redux';
import { compose } from 'redux';
import { isEmpty } from 'ramda';

import store from '../../store';
import useBannerSettings from '../../hooks/useBannerSettings';
import { bannerSettingsRestHooks } from '../../store/BannerSettings/BannerSettingsSlice';
import { useFetchStatus } from '../../utils/fetchStatusUtils';

import BannerSettingsTable from './components/BannerSettingsTable';
import EditSettingModal from './components/EditSettingModal';
const BannerSettingsContainer = () => {
  const {
    loadBannerSettings,
    bannerSetting: { errors },
    bannerSettings: { loadingStatus, items },
  } = bannerSettingsRestHooks.use();

  const { updateAndLoadSettings } = useBannerSettings();
  const { isFulfilled } = useFetchStatus(loadingStatus);

  const [isEditDialogOpen, setEditDialogOpen] = useState(false);
  const [currentBannerSetting, setCurrentBannerSetting] = useState({});

  useEffect(() => {
    loadBannerSettings();
  }, []);

  const handleEditDialogClose = () => {
    setEditDialogOpen(false);
  };
  const handleEditBannerSetting = (setting) => {
    setCurrentBannerSetting(setting);
    setEditDialogOpen(true);
  };

  const handleBannerSettingUpdate = async (...params) => {
    await updateAndLoadSettings(...params);
    handleEditDialogClose();
  };

  return (
    <div className="banner-settings">
      <div className="form-header">
        <h2>Banner Settings</h2>
      </div>
      <div>
        {!isEmpty(currentBannerSetting) && (
          <EditSettingModal
            onEditDialogClose={handleEditDialogClose}
            isEditDialogOpen={isEditDialogOpen}
            currentBannerSetting={currentBannerSetting}
            onUpdate={handleBannerSettingUpdate}
            errors={errors}
          />
        )}
        {isFulfilled && (
          <BannerSettingsTable
            bannerSettings={items}
            loadingStatus={loadingStatus}
            onEditBannerSetting={handleEditBannerSetting}
          />
        )}
      </div>
    </div>
  );
};

const addStore = (ProxyComponent) => (props) =>
  (
    <Provider store={store}>
      <ProxyComponent {...props} />
    </Provider>
  );

export default compose(addStore)(BannerSettingsContainer);
